import { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, ArrowRight } from "lucide-react";
import { Logo } from "@/components/Logo";

const NAV = [
  { to: "/assessment", label: "Eligibility Check" },
  { to: "/calculator", label: "Stream Calculator" },
  { to: "/results", label: "Results" },
  { to: "/draws", label: "Draws" },
  { to: "/streams", label: "Stream Matrix" },
  { to: "/rules", label: "Rules Engine" },
  { to: "/methodology", label: "Methodology" },
];

export function SiteHeader() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  return (
    <header className="sticky top-0 z-50 border-b border-slate-200 bg-white/95 backdrop-blur-md shadow-sm">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-8">
        <Logo />
        <nav className="hidden items-center gap-1 lg:flex" data-testid="main-nav">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              data-testid={`nav-${item.label.toLowerCase().replace(/\s+/g, "-")}-link`}
              className={({ isActive }) =>
                `rounded-md px-3 py-2 text-sm font-semibold transition-colors ${
                  isActive ? "text-[#C8102E]" : "text-slate-600 hover:text-slate-900"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>
        <div className="hidden lg:block">
          <Link
            to="/assessment"
            data-testid="header-start-assessment-btn"
            className="inline-flex items-center gap-1.5 rounded-md bg-[#C8102E] px-4 py-2 text-sm font-semibold text-white shadow-sm transition-colors hover:bg-[#A60C24]"
          >
            Start Assessment <ArrowRight className="h-4 w-4" />
          </Link>
        </div>
        <button
          onClick={() => setOpen((o) => !o)}
          data-testid="mobile-menu-toggle"
          className="inline-flex h-11 w-11 items-center justify-center rounded-md text-slate-700 lg:hidden"
          aria-label="Toggle menu"
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>
      {open && (
        <div className="border-t border-slate-200 bg-white lg:hidden" data-testid="mobile-nav">
          <div className="space-y-1 px-4 py-3">
            {NAV.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                onClick={() => setOpen(false)}
                className={`block min-h-[48px] rounded-md px-3 py-3 text-base font-semibold ${
                  location.pathname === item.to ? "bg-[#FEF2F2] text-[#C8102E]" : "text-slate-700"
                }`}
              >
                {item.label}
              </Link>
            ))}
            <Link
              to="/assessment"
              onClick={() => setOpen(false)}
              className="mt-2 block min-h-[48px] rounded-md bg-[#C8102E] px-3 py-3 text-center text-base font-semibold text-white"
            >
              Start Assessment
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
